module.exports = __webpack_public_path__ + "static/media/earn-more-icon.e2af84c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Icons/earn-more-icon.svg
// module id = 704
// module chunks = 0